import { isAfter, isBefore, parseISO, startOfToday, subYears } from 'date-fns';
import type { z } from 'zod';

import i18n from '@/lib/i18n';
import { EARLIEST_BIRTH_DATE } from '@/services/api/profile';
import { type DateParts, isDatePartsValid, toDateFromParts } from '@/utils/date';

const MINIMUM_AGE = 18;

export const dateOfBirthRefinement = (data: DateParts, context: z.RefinementCtx) => {
  if (!data.day || !data.month || !data.year) return;

  if (!isDatePartsValid(data)) {
    context.addIssue({
      code: 'custom',
      message: i18n.t('personalInformation.errors.dateOfBirth'),
      path: [],
    });
  }

  if (isAfter(toDateFromParts(data), subYears(startOfToday(), MINIMUM_AGE))) {
    context.addIssue({
      code: 'custom',
      message: i18n.t('personalInformation.errors.dateOfBirthAgeRestriction'),
      path: [],
    });
  }

  // A year short of four digits has its own error, which a date-level one would replace
  const hasFullYear = /^\d{4}$/.test(data.year);

  if (hasFullYear && isDatePartsValid(data) && isBefore(toDateFromParts(data), parseISO(EARLIEST_BIRTH_DATE))) {
    context.addIssue({
      code: 'custom',
      message: i18n.t('personalInformation.errors.dateOfBirthTooEarly'),
      path: [],
    });
  }
};
